import { filter } from "lodash-es";

import {
  buildCitationRefs,
  CkeditorConstants,
  checkIsCitation
} from "../../src/utils";
import randomUUIDGenerator from "../../src/utils/randomUUIDGenerator";

const {
  suggestionType: { INSERTION, DELETION },
  commentAttributes: { APPROVE, RESOLVE, REJECT, TIMESTAMP, USERNAME },
  commentsMarkup,
  trackchangesMarkup,
  treeWalkerValueType,
  command: {
    ACCEPT_SUGGESTION,
    ACCEPT_ALL_SUGGESTIONS,
    DISCARD_ALL_SUGGESTION,
    DISCARD_SUGGESTION,
    DISCARD_SELECTED_SUGGESTIONS,
    SAVE,
    CITATIONS
  },
  event: { CITATIONS_DELETE_FROM_DOCUMENT, EXECUTE, COMMENT_STATUS_THREAD_ID },
  helperAttributes: { DATA_UNLOCK, CONTENTEDITABLE, NUMBERED_CITATION, RENUMBER_CITATIONS, REMOVE_INSERTEDCITATION_DISCARD, SUBTEMPLATE_NAME, RESOURCE, REMOVE_KEYWORD_FROM_SUBTEMPLATES, TYPE_OF, LINK_HREF, DISCARD_CITATION, PARENT_CITATION, DATA_IGNORE, NO_ONE },
  attributeLinkOtherDocument,
  attributeWebLink,
  htmlAttributes: { ABOUT, CLASS, ID, REL, NUMBERED_CITATION_CLASS },
  htmlElement: { PARAGRAPH, LINK_SPAN, SPAN, DIV, LIST_ITEM },
  HEADINGS,
  elementClass: { suggestion_deletion_marker, WIDGET_SELECTED, suggestion_marker },
  class: { WK_KEYWORD_REF },
  localStorageItem: { KEYWORD_DATA, REMOVE_MARKER_OF_LINK },
  operation: { UNDO },
  linksTo,
  attributeMediaResource,
  htmlTagNames: { P },
  unLockValues: { no_one },
  PLUGINS: { PERMISSIONS, RELEASE_NOTES, TRACKCHANGE_EDITING },
  COMMENT_PERMISSIONS
} = CkeditorConstants;

export default class TrackChangesAndCommentsIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    try {
      const appData = {
        suggestions: [],
      };
      appData.initialData = this.editor.getData();
      const currentUserData = JSON.parse(localStorage.getItem("currentUser"));
      let trackChangesAndCommentsInvolvedUser = JSON.parse(localStorage.getItem(
        "trackChangesAndCommentsInvolvedUsers"
      )) || [];
      // Users data.
      if (
        !trackChangesAndCommentsInvolvedUser?.some(
          (ele) => ele.id === currentUserData.id
        )
      ) {
        trackChangesAndCommentsInvolvedUser.push(currentUserData);
      }
      appData.users = trackChangesAndCommentsInvolvedUser;
      // The ID of the current user.
      appData.userId = currentUserData.id;
      const trackChangesAndCommentsData = JSON.parse(
        localStorage.getItem("trackchangesandcommentsdata") || '{}'
      );
      const usersPlugin = this.editor.plugins.get("Users");
      const commentsRepositoryPlugin =
        this.editor.plugins.get("CommentsRepository");
      const trackChangesPlugin = this.editor.plugins.get("TrackChanges");
      const trackChangesEditing = this.editor.plugins.get(TRACKCHANGE_EDITING);

      // Load the users data.
      for (const user of appData.users) {
        usersPlugin.addUser(user);
      }

      // Set the current user.
      usersPlugin.defineMe(appData.userId);

      // "Commentator" role.
      this.editor.plugins.get(PERMISSIONS).setPermissions(COMMENT_PERMISSIONS);

      if (trackChangesAndCommentsData?.commentThreads?.length > 0) {
        for (const commentThread of trackChangesAndCommentsData.commentThreads) {
          commentsRepositoryPlugin.addCommentThread(commentThread);
        }
      }

      // Load the suggestions data.
      if (trackChangesAndCommentsData?.suggestions?.length > 0) {
        for (const suggestion of trackChangesAndCommentsData.suggestions) {
          trackChangesPlugin.addSuggestion(suggestion);
        }
      }



      this.editingRootDomElement = this.editor.editing.view.domRoots.get("main");

      const acceptSuggestionEvent = this.editor.commands.get(ACCEPT_SUGGESTION);
      const trackChangesAttributesToRemove = Object.values(trackchangesMarkup);
      acceptSuggestionEvent.on("execute", (_event, suggestion) => {
        const trackChangeAttrEleFound = [];
        const suggestionId =
          typeof suggestion === "string"
            ? suggestion
            : typeof suggestion[0] === "string"
              ? suggestion[0]
              : " ";
        const suggestionData = trackChangesEditing.getSuggestion(suggestionId);
        const { attributes: { commandParams } } = suggestionData;
        if (commandParams?.refsToBeReOrdered?.length > 0) {
          const { refsToBeReOrdered } = commandParams;
          for (let i = 0; i < refsToBeReOrdered.length; i++) {
            this.editor.model.change((writer) => {
              if (i === 0) {
                writer.removeAttribute(PARENT_CITATION, refsToBeReOrdered[i]);
              } else {
                writer.setAttribute(PARENT_CITATION, refsToBeReOrdered[0]?.getAttribute(ID), refsToBeReOrdered[i]);
              }
            });
          }
        }

        if (commandParams?.citationsToBeDeleted) {
          this.editor.fire(CITATIONS_DELETE_FROM_DOCUMENT, { multipleRefs: commandParams.citationsToBeDeleted });
        }
        // Cleanup trackchanges attributes created by CK5
        const range = this.editor.model.createRangeIn(
          this.editor.model.document.getRoot()
        );
        for (const item of range.getItems({ ignoreElementEnd: true })) {
          trackChangesAttributesToRemove.forEach((trackChangeAttr) => {
            if (
              item.hasAttribute(trackChangeAttr) &&
              item.getAttribute(trackChangeAttr).includes(suggestionId)
            ) {
              trackChangeAttrEleFound.push(item);
            }
          });
        }
        this.removeTrackChangeMarkups(
          trackChangesAttributesToRemove,
          trackChangeAttrEleFound
        );
        this.addPTagOnUnlockDiv();
        this.editor.execute('removesubtemplate');
        this.moveIncorrectISTChild();
      });

      const acceptSuggestionAllEvent = this.editor.commands.get(
        ACCEPT_ALL_SUGGESTIONS
      );
      acceptSuggestionAllEvent.on("execute", (_, rightPanelOptions) => {
        const trackChangeAttrEleFound = [];
        // Cleanup trackchanges attributes on acceptAllSuggestions created by CK5
        const range = this.editor.model.createRangeIn(
          this.editor.model.document.getRoot()
        );
        for (const item of range.getItems({ ignoreElementEnd: true })) {
          trackChangesAttributesToRemove.forEach((trackChangeAttr) => {
            if (item.hasAttribute(trackChangeAttr)) {
              trackChangeAttrEleFound.push(item);
            }
          });
        }
        this.removeTrackChangeMarkups(
          trackChangesAttributesToRemove,
          trackChangeAttrEleFound
        );
        if (rightPanelOptions[0]) {
          this.editor.focus();
        }
        this.editor.execute("removeistsubtemplate");
        this.editor.execute('removesubtemplate');
      });

      const discardAllSuggestionOn = this.editor.commands.get(
        DISCARD_ALL_SUGGESTION
      );
      const discardSelectedSuggestionOn = this.editor.commands.get(
        DISCARD_SELECTED_SUGGESTIONS
      );
      [discardAllSuggestionOn, discardSelectedSuggestionOn].forEach((event) => {
        event.on(EXECUTE, (evt, rightPanelOptions) => {
          rightPanelOptions[0] && this.editor.focus();
          this.addPlaceHolderTagsForSubtemplate();
        });
      });

      const discardSuggestionOn = this.editor.commands.get(DISCARD_SUGGESTION);
      discardSuggestionOn.on(
        "execute",
        (_, suggestionData) => {
          const suggestionId = suggestionData[0];
          const suggestion = trackChangesEditing.getSuggestion(suggestionId);
          const [markerName] = suggestion.getMarkerNames();
          const [targetElement] = suggestion.getItems();
          let removeLinkFromTrackChanges = false;

          const isLinkTarget = this.isLinkTypeSuggestion(targetElement);
          const isLinkTargetParent = targetElement?.parent ? this.isLinkTypeSuggestion(targetElement.parent): null;
          removeLinkFromTrackChanges =
            this.getRemoveLinkFrmTrackChangAttrVal(suggestion);

          if (
            (isLinkTarget || isLinkTargetParent) &&
            !removeLinkFromTrackChanges
          ) {
            const linkEle = isLinkTargetParent
              ? targetElement?.parent
              : isLinkTarget && targetElement;
            const adjacentSuggestions = suggestion
              .getAllAdjacentSuggestions()
              .filter((suggestion) => suggestion.type === INSERTION);

            // Get the DOM element related to the suggestion
            const suggestionElement = this.editor.editing.view.domRoots.get('main').querySelector(`[data-suggestion="${suggestion.id}"]`);


            if (suggestionElement) {
              const { parentElement: { nextElementSibling, previousElementSibling } } = suggestionElement;
              // Check if siblings meet the criteria for discarding
              const isNextSiblingValid = !nextElementSibling?.classList.contains(suggestion_marker);
              const isPreviousSiblingValid = !previousElementSibling?.classList.contains(suggestion_marker);

              const { attributes, type } = suggestion;
              // If all conditions are met, discard the suggestion if it is a link
              if (isNextSiblingValid && isPreviousSiblingValid && (!attributes.commandParams?.isTextMarkedInGreen) && attributes.commandParams && type !== DELETION) {
                this.discardSuggIfLink(markerName, linkEle);
              }
            }
            for (const suggestion of adjacentSuggestions) {
              this.callDiscardSuggestions(suggestion);
            }
          } else {
            const adjacentSuggestions = suggestion
              .getAllAdjacentSuggestions()
              .filter((suggestion) => suggestion.type === INSERTION);
            const itemToDelete = [];
            this.editor.model.change((writer) => {
              try {
                if (adjacentSuggestions?.length) {
                  const { commandParams } = suggestion.attributes;
                  if (commandParams?.linkBeforeEdit) {
                    const {
                      linkTextBeforeEdit,
                      linkAddressBeforeEdit,
                      linkBeforeEdit: { id, about, rel, typeofAtr, classAtr }
                    } = commandParams;
                    const linkSpan = writer.createElement(LINK_SPAN);
                    let removeMarkerOfLinks = [];
                    writer.insertText(linkTextBeforeEdit, linkSpan);
                    const removeMarkerLinkId = localStorage.getItem(REMOVE_MARKER_OF_LINK);
                    removeMarkerLinkId && removeMarkerOfLinks.push(JSON.parse(removeMarkerLinkId));
                    removeMarkerOfLinks.push(id);
                    localStorage.setItem(REMOVE_MARKER_OF_LINK, JSON.stringify(removeMarkerOfLinks));
                    writer.setAttributes({
                      id,
                      about,
                      rel,
                      'typeof': typeofAtr,
                      'class': classAtr,
                      'resource': linkAddressBeforeEdit
                    }, linkSpan);
                    this.editor.model.insertContent(linkSpan, this.positionToInsertLink);
                  }
                  adjacentSuggestions.forEach((adjSuggestion) => {
                    for (const value of adjSuggestion.getRanges()) {
                      for (const itemInSelection of value.getWalker()) {
                        if (
                          itemInSelection.type &&
                          itemInSelection.type !== treeWalkerValueType.Element_End
                        ) {
                          itemToDelete.push(itemInSelection.item);
                        }
                      }
                    }
                  });
                }

                const tagsWithOutEmptyPara = this.getTagsWithOutEmptyPara(itemToDelete);
                [...tagsWithOutEmptyPara].forEach((itemInSelection) => {
                  writer.remove(itemInSelection);
                });
              } catch (err) {
                console.log(err);
              } finally {
                // this.callDiscardSuggestions(suggestion);
              }
            });
          }
          this.addPlaceHolderTagsForSubtemplate();
          this.addPTagOnUnlockDiv();
        },
        { priority: "high" }
      );

      acceptSuggestionEvent.on('execute', (_, suggestionData) => {
        let suggestionId = ' ';
        if (typeof suggestionData === 'string') {
          suggestionId = suggestionData;
        } else if (typeof suggestionData[0] === 'string') {
          suggestionId = suggestionData[0];
        }
        const suggestion = trackChangesEditing.getSuggestion(suggestionId);
        let removeLinkFromTrackChanges = false;
        let isLinkHref = false;
        let isEditedLink = false;
        let isLinkTarget = false;
        let isLinkTargetParent = false;
        const [markerName] = suggestion.getMarkerNames();
        const [targetElement] = suggestion.getItems();
        if (suggestion.subType === 'deleteLink') {
          isLinkHref = true;
          removeLinkFromTrackChanges = true;
        } else {
          this.isKeywordPresentInSubtemplate(suggestionId);
          isLinkTarget = this.isLinkTypeSuggestion(targetElement);
          isLinkTargetParent =
            targetElement?.parent ?
              this.isLinkTypeSuggestion(targetElement.parent) :
              null;
          const { type, attributes: { commandParams } } = suggestion;
          let deleteLink = false;
          suggestion.getAllAdjacentSuggestions().forEach((adjSuggestion) => {
            for (const value of adjSuggestion.getRanges()) {
              for (const itemInSelection of value.getWalker()) {
                if (
                  itemInSelection.type &&
                  itemInSelection.item?.textNode &&
                  itemInSelection.item?.data === itemInSelection.item?.textNode?._data
                ) {
                  deleteLink = true;
                  return;
                }
              }
            }
          });
          if (type === DELETION && !((commandParams?.removeLinkFromTrackChanges || commandParams?.removeSubtemplate)) && deleteLink) {
            this.removeLinkRDFaRemains(suggestion.getItems(), isLinkTargetParent, targetElement);
          }
          if (
            suggestion.attributes?.commandParams?.hasOwnProperty(
              "removeLinkFromTrackChanges"
            )
          ) {
            removeLinkFromTrackChanges =
              suggestion.attributes.commandParams["removeLinkFromTrackChanges"];
          }
          if (
            suggestion.attributes?.commandParams?.hasOwnProperty(
              "linkBeforeEdit"
            )
          ) {
            isEditedLink =
              suggestion.attributes.commandParams["linkBeforeEdit"];
          }
          if (
            targetElement?.textNode?.getAttribute('linkHref')
          ) {
            isLinkHref = true;
          }
        }
        if (
          (isLinkTarget || isLinkTargetParent || isLinkHref) &&
          removeLinkFromTrackChanges &&
          !isEditedLink
        ) {
          this.editor.model.change((writer) => {
          if (targetElement?.parent?._attrs?.get('id')) {
              this.editor.execute('unwraplink', [targetElement.parent._attrs.get('id')]);
            }
            writer.removeMarker(markerName);
            if (isLinkHref && targetElement?.textNode) {
              writer.removeAttribute('linkHref', targetElement.textNode);
            }
            else if (isLinkTargetParent) {
              writer.unwrap(targetElement.parent);
            } else if (isLinkTarget) {
              writer.unwrap(targetElement);
            }
          });
        }
        if (suggestion.type === DELETION) {
          this.editor.execute("removeistsubtemplate");
        }
        this.editor.execute("removesubtemplate");
      }, { priority: "high" });

      const commentRepositoryEvents = [
        commentsMarkup.ADD_COMMENT,
        commentsMarkup.REMOVE_COMMENT,
        commentsMarkup.UPDATE_COMMENT,
        commentsMarkup.REMOVE_COMMENT_THREAD
      ];

      commentRepositoryEvents.forEach((commandName) => {
        commentsRepositoryPlugin.on(commandName, (_event, data) => {
          const suggestionBalloonView = document.getElementsByClassName('ck-balloon-rotator__content')[0]?.getElementsByClassName('ck-annotation-wrapper')[0];
          if (commandName !== commentsMarkup.REMOVE_COMMENT) {
            const commentThreadStatus = {
              threadId: data?.threadId ?? "",
              status: data?.attributes?.status ?? "draft"
            };
            if (
              (data?.attributes?.status === APPROVE ||
                data?.attributes?.status === REJECT)
            ) {
              if (
                data?.attributes?.hasOwnProperty(TIMESTAMP) &&
                data?.attributes?.hasOwnProperty(USERNAME)
              ) {
                this.editor.fire(COMMENT_STATUS_THREAD_ID, {
                  value: commentThreadStatus,
                });
              }
            } else {
              this.editor.fire(COMMENT_STATUS_THREAD_ID, {
                value: commentThreadStatus,
              });
            }
            this.editor.commands.get(SAVE).isEnabled && this.setSaveOption(false);
          } else if (suggestionBalloonView && commandName === commentsMarkup.REMOVE_COMMENT) {
            this.editor.fire(COMMENT_STATUS_THREAD_ID, { value: {} })
            this.editor.commands.get(SAVE).isEnabled && this.setSaveOption(false);
          } else {
            this.setSaveOption(true);
          }
        });
      });

      trackChangesEditing.on(
        "change:activeMarkers",
        (evt, data, value, oldvalue) => {
          if (value.length > 0) {
            const commentId = value[0].split(":")[2];
            this.editor.fire("activemarker", commentId);
          }
          this.editingRootDomElement?.querySelectorAll(`.${RELEASE_NOTES}.${WIDGET_SELECTED}`).forEach((releaseNote) => {
            releaseNote.classList?.remove(WIDGET_SELECTED);
          });
        }
      );

      const addCommentThreadCommand = this.editor.commands.get("addCommentThread");

      /**
       * Disable the "Add comment" toolbar button whenever a numbered citation
       * widget is selected.
       */
      this.editor.model.document.selection.on('change', () => {
        if (checkIsCitation(this.editor)) {
          addCommentThreadCommand.forceDisabled(CITATIONS);
        } else {
          addCommentThreadCommand.clearForceDisabled(CITATIONS);
        }
      });

      addCommentThreadCommand.on("execute", () => {
        const commentThreads = this.editor.plugins
          .get("CommentsRepository")
          .getCommentThreads();
        const lastId = commentThreads?.[commentThreads.length - 1]?.id;
        if (lastId) {
          this.editor.fire("addcommentthread", lastId);
          this.editor.commands.get(SAVE).isEnabled && this.setSaveOption(false);
        }
        else if (suggestionBalloonView && commandName === commentsMarkup.REMOVE_COMMENT) {
          this.editor.fire(COMMENT_STATUS_THREAD_ID, { value: {} })
          this.editor.commands.get(SAVE).isEnabled && this.setSaveOption(false);
        } else {
          this.setSaveOption(true);
        }
      });
    } catch (ex) {
      console.warn('TrackChangesAndCommentsIntegration====>', ex);
    }
  }

  checkDiscardedCitations(suggestion) {
    const citationRefSet = new Set();

    for (const value of suggestion.getRanges()) {
      for (const { item } of value.getWalker()) {
        if (item.name === NUMBERED_CITATION) {
          citationRefSet.add(item);
        } else if (item.textNode?.parent?.getAttribute(REL) === linksTo) {
          this.editor.model.change((writer) => {
            this.positionToInsertLink = writer.createPositionBefore(item.textNode.parent);
          });
        }
      }
    }

    const refs = [...citationRefSet];
    const citationRefs = buildCitationRefs(refs, this.editor, null);

    /**
     * If suggestion type is deletion then on discard the citation reference will remain
     * If suggestion type is insertion then on discard the citationr reference will be removed
     */
    if (suggestion.type === "insertion") {
      this.editor.fire(DISCARD_CITATION, { citationRefs });
    }
  }

  addPTagOnUnlockDiv() {
    const locationToAddNonEditablePTag = [];
    const locationToAddEditablePTag = [];
    const range = this.editor.model.createRangeIn(
      this.editor.model.document.getRoot()
    );
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (!item.childCount && item.hasAttribute("data-unlock") && !HEADINGS.includes(item.name)) {
        if (
          item.hasAttribute("data-noone") &&
          item.getAttribute("data-unlock") === "NO-ONE"

        ) {
          locationToAddNonEditablePTag.push(item);
        }

        if (
          item.getAttribute("data-unlock") === "ALL"
        ) {
          locationToAddEditablePTag.push(item);
        }
      }
    }

    locationToAddNonEditablePTag.forEach((dataNoOneEle) => {
      this.setContentEditable(dataNoOneEle, "false");
    });

    locationToAddEditablePTag.forEach((editableEle) => {
      this.setContentEditable(editableEle, "true");
    });
  }

  setContentEditable(element, val) {
    this.editor.model.change((writer) => {
      writer.setAttribute(CONTENTEDITABLE, val, element);
      const pTag = writer.createElement("paragraph");
      writer.setAttribute(CONTENTEDITABLE, val, pTag);
      writer.insert(pTag, element, "end");
      const undoCommand = this.editor.commands.get(UNDO);
      undoCommand._stack.forEach((operation) => {
        const item = operation.batch?.operations?.find((op) => op.key === CONTENTEDITABLE);
        const operationInUndoStack = item?.batch.operations.find((op) => op.root?.parent === element);
        if (item && operationInUndoStack?.root?.parent?.getAttribute(DATA_IGNORE) !== 'TRUE') {
          undoCommand._stack.splice(undoCommand._stack.indexOf(operation), 1);
        }
      })
    });
  }

  isLinkTypeSuggestion(element) {
    if (element) {
      const attributesMap = new Map(element.getAttributes());
      const typeofValue = attributesMap.get("typeof");
      const classList = attributesMap.get("class");
      const isWebTypeLink = typeofValue === attributeWebLink;
      const isDocumentTypeLink =
        typeofValue === attributeLinkOtherDocument &&
        classList &&
        !classList.includes("numbered-citation");
      const isPdfTypeLink = typeofValue === attributeMediaResource;
      return isWebTypeLink || isDocumentTypeLink || isPdfTypeLink;
    } else return null;
  }

  getRemoveLinkFrmTrackChangAttrVal(suggestion) {
    if (
      
      suggestion?.attributes?.commandParams?.hasOwnProperty(
        "removeLinkFromTrackChanges"
      )
    ) {
      return suggestion.attributes.commandParams["removeLinkFromTrackChanges"];
    }
  }

  discardSuggIfLink(markerName, linkEle) {
    this.editor.model.change((writer) => {
      writer.removeMarker(markerName);
      writer.unwrap(linkEle);
    });
  }

  callDiscardSuggestions(suggestion) {
    this.editor.plugins
      .get(TRACKCHANGE_EDITING)
      .discardSuggestion(suggestion);
  }

  removeTrackChangeMarkups(
    trackChangesAttributesToRemove,
    trackChangeAttrEleFound
  ) {
    this.editor.model.change((writer) => {
      const foundItemsLen = trackChangeAttrEleFound?.length;
      for (let i = 0; i < foundItemsLen; i++) {
        trackChangesAttributesToRemove.forEach((trackChangeAttr) => {
          if (trackChangeAttrEleFound[i].hasAttribute(trackChangeAttr)) {
            writer.removeAttribute(trackChangeAttr, trackChangeAttrEleFound[i]);
          }
        });
      }
    });
  }

  //To check if remove subtemplate section have keyword or not
  isKeywordPresentInSubtemplate(suggestionId) {
    this.editingRootDomElement = this.editor.editing.view.domRoots.get("main");
    const elementToRemove = this.editingRootDomElement?.querySelectorAll(`[data-suggestion='${suggestionId}']`);
    const keywordObj = [];
    elementToRemove.forEach(element => {
      const data = element.closest(`.${WK_KEYWORD_REF}`)
      data && keywordObj.push(data);
    });
    const keywordData = JSON.parse(localStorage.getItem(KEYWORD_DATA));
    if (keywordObj?.length) {
      const selectedKeyword = this.getKeywordsInSubtemplate(keywordObj)
      keywordObj.forEach(element => {
        let docRefId = '';
        const keywordId = element.getAttribute(ID);
        const resourceId = element.getAttribute(RESOURCE).split('/').pop();
        const groupByKeyword = Object.groupBy(selectedKeyword.map(x => x.keywordData), ({ resourceId }) => { return resourceId });
        for (const key in groupByKeyword) {
          
          if (key === resourceId && keywordData?.find(x => x.id === key)?.altLabels.length === groupByKeyword[key].length) {
            docRefId = 'all';
          }
        }
        if (element?.querySelector(`.${suggestion_deletion_marker}`)) {
          this.editor.fire(REMOVE_KEYWORD_FROM_SUBTEMPLATES, { keywordId: docRefId || keywordId, resourceId: resourceId });
        }
      });
    }
    return keywordObj;
  }

  /**
   * Get keywords present in subtemplate
   * @private
   * @param {Element[]} keywordObj
   * @returns {*}
   */
  getKeywordsInSubtemplate(keywordObj) {
    return keywordObj.map(element =>
    ({
      keywordData: {
        resourceId: element.getAttribute(RESOURCE).split('/').pop(),
        keywordId: element.getAttribute(ID)
      },
      selectedText: element.data
    })
    );
  }

  /**
   * Remove RDFa remains of link on deletion.
   */
  removeLinkRDFaRemains(elements, isLinkTargetParent, targetElement) {
    this.editor.model.change((writer) => {
      elements.forEach((element) => {
        if (
          element.is("element") &&
          ([...element.getAttributeKeys()].includes(CLASS) &&
            (element.getAttribute(CLASS) !== WK_KEYWORD_REF &&
              !element.getAttribute(CLASS).includes(NUMBERED_CITATION_CLASS))) &&
          [...element.getAttributeKeys()].includes(REL) &&
          element.getAttribute(REL) === linksTo
        ) {
          writer.remove(element);
        }
      });
      if (isLinkTargetParent) {
        writer.remove(targetElement.parent);
      }
    });
  }

  /**
   * IST subsection structure contains two child's by default, but on incorrect merge using Backspace/other it appended with third child so here's
   * moving that incorrect third child next to subtemplate.
   */
  moveIncorrectISTChild() {
    this.editor.model.change((writer) => {
      [...this.getAllISTContainWrongChild(writer)].forEach((element) => {
        try {
          const spanEndPos = writer.createPositionAt(element, "end");
          const ItemAfterDefaultPos = writer.createPositionAt(element.getChild(1), "after");
          const movableRange = writer.createRange(ItemAfterDefaultPos, spanEndPos);
          writer.move(movableRange, element, "after");
        } catch (err) {
          console.warn(err)
        }
      });
    });
  }

  /**
  * Get all IST Subsection which contains more than two child in model document.
  */
  getAllISTContainWrongChild(writer) {
    const range = writer.createRangeIn(
      this.editor.model.document.getRoot("main")
    );
    return [...range.getItems()].filter(
      (item) => item?.name === SPAN && item._attrs && item.hasAttribute(SUBTEMPLATE_NAME) && item.childCount > 2
    );
  }

  /**
   * 
   * @param itemToDelete elements in current discarded suggestion range
   * @returns filtered elements which is not empty paragraph

   */

  getTagsWithOutEmptyPara(itemToDelete) {
    const { mapper } = this.editor.editing;

    return filter(itemToDelete, itemInSelection => {
      const nextSibling = itemInSelection.nextSibling;
      const previousSibling = itemInSelection.previousSibling;

      const toViewEle = mapper.toViewElement(itemInSelection);
      const getAncestors = toViewEle && toViewEle.getAncestors();
      let isSubtemplate = getAncestors && [...getAncestors].filter((item) => {
        if (item.hasAttribute(SUBTEMPLATE_NAME) && item.name !== SPAN) {
          isSubtemplate = item;
        }
      });

      const nextSiblingViewEle = mapper.toViewElement(nextSibling);
      const previousSiblingViewEle = mapper.toViewElement(previousSibling);

      // Checks for p tags which are not present inside block subtemplates
      const isPTag =  itemInSelection?.name === PARAGRAPH && !isSubtemplate.length;

      const isEmptyPara = isPTag && itemInSelection.isEmpty

      // Checks for placeholders p tags which are present before and after block subtemplates
      const hasSubtemplateNeighbor =
      nextSibling &&
    nextSiblingViewEle?.hasAttribute(SUBTEMPLATE_NAME) ||
    previousSibling &&
    previousSiblingViewEle?.hasAttribute(SUBTEMPLATE_NAME);
    

      return !isPTag || (isEmptyPara && hasSubtemplateNeighbor);
    });
  }


  /**
   * Checks and adds placeholder tags before and after inserted subtemplates
   */
  addPlaceHolderTagsForSubtemplate() {
    const range = this.editor.editing.view.createRangeIn(this.editor.editing.view.document.getRoot());

    this.editor.model.enqueueChange({ isUndoable: false }, (writer) => {
      for (const item of range.getItems({ ignoreElementEnd: true })) {

        try {
          // Checks block subtemplates elements with data-subtemplate-name attributes 
          if (item._attrs && item.hasAttribute(SUBTEMPLATE_NAME) && item.name !== SPAN && item.parent.name !== LIST_ITEM) {

            // True if parent of subtemplate is non editable
            const isParentDataUnlockNoOne = item.parent?.hasAttribute(DATA_UNLOCK) && item.parent?.getAttribute(DATA_UNLOCK) === no_one
            const isPreviousSiblingIsPlaceholder = !item.previousSibling || item.previousSibling.name === P || (item.previousSibling.name === DIV && item.previousSibling.hasAttribute(NO_ONE));
            const isNextSiblingIsPlaceholder = item.nextSibling?.name === P || (item.nextSibling?.name === DIV && item.nextSibling?.hasAttribute(NO_ONE));
            const modelItem = this.editor.editing.mapper.toModelElement(item);



            if (isPreviousSiblingIsPlaceholder) {
              this.fetchPlaceholder(writer, modelItem, isParentDataUnlockNoOne, "before")
            }
            if (!isNextSiblingIsPlaceholder) {
              this.fetchPlaceholder(writer, modelItem, isParentDataUnlockNoOne, "after")
            }
          }
        } catch (err) {
          console.warn(err);
        }
      }
    });
  }

  /**
   * Enables / Disables save button
   * @param {boolean} enableSaveButton
   */
  setSaveOption(enableSaveButton) {
    this.editor.commands.get(SAVE).isEnabled = enableSaveButton;
    this.editor.commands.get(SAVE).hasUnsavedChanges = enableSaveButton;
  }

  /** 
   * @param writer model writer 
   * @param modelItem modelItem will be block subtemplate element
   * @param isNonEditableParent Boolean value which will be true if block subtemplate parent data-unlock !== 'NO-ONE'
   * @param positionToCreate Before / After Position of subtemplate to create placeholder  
   */
  fetchPlaceholder(writer, modelItem, isNonEditableParent, positionToCreate) {
    try {
      const placeholderTag = isNonEditableParent ? writer.createElement(DIV, { [CONTENTEDITABLE]: 'false', [NO_ONE]: randomUUIDGenerator() }) : writer.createElement(PARAGRAPH, { [CONTENTEDITABLE]: 'true' });
      writer.insert(placeholderTag, modelItem, positionToCreate);
    } catch (err) {
      console.warn(err);
    }
  }
}